<template>
	<div id="main-component" :data-version="version">
		<component :is="layout" v-bind="templateProps">
			<router-view :layout.sync="layout" @update:templateProps="handleUpdateProps" />
		</component>
	</div>
</template>

<script type="text/javascript">
import { mapActions, mapGetters } from 'vuex';
import _get from 'lodash.get';

export default {
	data: () => ({ layout: 'div', templateProps: null, version: process.env.VERSION }),
	computed: {
		...mapGetters('lang', ['lang', 'languages'])
	},
	async created() {
		const { locale } = this.$route.query || {};
		if (locale) {
			const code = _get(
				this.languages.find(({ code }) => code === locale),
				'code'
			);
			if (code && code !== this.lang) {
				this.setLanguage(code);
			}
		}
		await this.loadLanguage({ lang: this.lang });
	},
	methods: {
		...mapActions('lang', ['loadLanguage', 'setLanguage']),
		handleUpdateProps(props) {
			this.templateProps = props;
		}
	}
};
</script>
